export const environment = {
    production: false,
    backendUrl: 'opinto-opas-lay.demopeppi4.lapit.csc.fi',
    primaryLang: 'fi',
    secondaryLang: 'en',
    tertiaryLang: '',
    redirectRoute: '/fi/etusivu/53896',
    frontPageRoute: {valueFi: '/fi/etusivu/53896', valueEn: '/en/front-page/53896', valueSv: '/'},
    // tähän organisaatiopuun juuren id
    frontPageOrganisationIndex: '63',
    logo: 'assets/lappi/logo',
    favicon: 'assets/lappi/favicon.ico',
    background: 'assets/lappi/LaY-tausta.png',
    headerTransparency: true,
    // tähän voi antaa osoitteen, josta injektoidaan jokin javascript-tiedosto <HEAD>-tagien sisään
    analyticsIcluded: false,
    analytics: '',
    // sivujen title-tiedon perään lisättävä lisäke
    titleExtension: ' | Opinto-opas',
    showSearchField: true,
    showTermSelection: false,
    firstSchoolYear: 2020,
    currentPeriodStartYear: 2022,
    searchPeriod: 2022,
    curriculumPeriod: 2,
    showTags: false
  };
  
